import axios from 'axios';

export interface AssignWorkspaceGreetsActionProps {
  greetIds: string[];
  campaignId: number;
}

export default async function assignWorkspaceGreetsAction({
  greetIds,
  campaignId,
}: AssignWorkspaceGreetsActionProps) {
  return await axios('/api/v2/greets', {
    method: 'PATCH',
    data: {
      campaign_id: campaignId,
      greets: greetIds,
    },
  }).then((res) => res.data);
}
